import Loadable from 'react-loadable';
import LoadingSpinner from '../../LoadingSpinner/index';
import BlankLoader from '../../LoadingSpinner/loaderBlank';
import ConfigLoader from '../../LoadingSpinner/ConfigLoader';
import ChooseColorLoader from '../../LoadingSpinner/ChooseColorLoader';

const resolveLoadableComponent = (module) => module.default || module;

const createLoadableTemplate = (loader, loading) =>
  Loadable({
    loader: () => loader().then(resolveLoadableComponent),
    loading,
  });

const CountertopDraftingToolTemplate = createLoadableTemplate(
  () => import('./countertopDraftingToolTemplate/index'),
  LoadingSpinner
);

const DefaultTemplate = createLoadableTemplate(
  () => import('./default/index'),
  ConfigLoader
);

const EdgeStyleTemplate = createLoadableTemplate(
  () => import('./defaultWithLabelsSelectFirst/index'),
  LoadingSpinner
);

const DefaultWithLabelsTemplate = createLoadableTemplate(
  () => import('./defaultWithLabels/index'),
  ConfigLoader
);

const HiddenTemplate = createLoadableTemplate(
  () => import('./hidden/index'),
  BlankLoader
);

const StepperTemplate = createLoadableTemplate(
  () => import('./stepper/index'),
  LoadingSpinner
);

const BannerTemplate = createLoadableTemplate(
  () => import('./banner/index'),
  LoadingSpinner
);

const SurfaceMaterialCarouselTemplate = createLoadableTemplate(
  () => import('./surfaceMaterialCarousel/index'),
  ConfigLoader
);

const ChoiceCarouselTemplate = createLoadableTemplate(
  () => import('./choiceCarousel/index'),
  LoadingSpinner
);

const ColorWPriceAltStyleTemplate = createLoadableTemplate(
  () => import('./ColorWPriceAltStyle/index'),
  ChooseColorLoader
);

const ChoiceStepperTemplate = createLoadableTemplate(
  () => import('./choiceStepper/index'),
  LoadingSpinner
);

const RadioButtonWithCopyTemplate = createLoadableTemplate(
  () => import('./radioButtonWithCopy/index'),
  LoadingSpinner
);

const SimpleChoiceStepperTemplate = createLoadableTemplate(
  () => import('./simpleChoiceStepper/index'),
  LoadingSpinner
);

const RadioButtonWithCopyHideIfOneTemplate = createLoadableTemplate(
  () => import('./radioButtonWithCopyHideIfOne/index'),
  LoadingSpinner
);

const InfoTileTemplate = createLoadableTemplate(
  () => import('./infoTile/index'),
  LoadingSpinner
);

const MarkdownWithCopyTemplate = createLoadableTemplate(
  () => import('./markdownWithCopy/index'),
  LoadingSpinner
);

const ChoiceWithRadioButtonsTemplate = createLoadableTemplate(
  () => import('./ChoiceWithRadioButtons/index'),
  LoadingSpinner
);
const DropDownWithPriceTemplate = createLoadableTemplate(
  () => import('./dropdownWithPrice/DropDownWithPriceTemplate'),
  LoadingSpinner
);

const SqFtDecimalInputTemplate = createLoadableTemplate(
  () => import('./sqFtDecimalInput/index'),
  LoadingSpinner
);

const SurfaceThicknessTemplate = createLoadableTemplate(
  () => import('./surfaceThickness/index'),
  LoadingSpinner
);

const templates = {
  Default: DefaultTemplate,
  Hidden: HiddenTemplate,
  Banner: BannerTemplate,
  ChoiceCarousel: ChoiceCarouselTemplate,
  SurfaceMaterial: SurfaceMaterialCarouselTemplate,
  Stepper: StepperTemplate,
  ColorWPriceAltStyle: ColorWPriceAltStyleTemplate,
  ChoiceStepper: ChoiceStepperTemplate,
  SimpleChoiceStepper: SimpleChoiceStepperTemplate,
  RadioButtonWithCopy: RadioButtonWithCopyTemplate,
  InfoTile: InfoTileTemplate,
  RadioButtonWithCopyHideIfOne: RadioButtonWithCopyHideIfOneTemplate,
  MarkdownWithCopy: MarkdownWithCopyTemplate,
  ChoiceWithRadioButtons: ChoiceWithRadioButtonsTemplate,
  DefaultWithLabels: DefaultWithLabelsTemplate,
  EdgeStyle: EdgeStyleTemplate,
  DropdownWithPrice: DropDownWithPriceTemplate,
  SqFtDecimalInput: SqFtDecimalInputTemplate,
  SurfaceThickness: SurfaceThicknessTemplate,
  CountertopDraftingTool: CountertopDraftingToolTemplate,
};

export default templates;
